import * as Yup from "yup";

// Valida horários HH:MM
const TIME_REGEX = /^([0-1]\d|2[0-3]):[0-5]\d$/;

export const sessionSchema = Yup.object().shape({
    idClass: Yup.string()
        .required("A sessão precisa vir de uma turma originária"),
    idActivity: Yup.string()
        .required("Selecione qual a atividade/modalidade dessa sessão"),
    activityName: Yup.string().nullable(),
    activityColor: Yup.string().nullable(),
    evaluationSystem: Yup.boolean().default(false),

    idEmployee: Yup.string()
        .required("O professor para o dia é obrigatório"),
    employeeName: Yup.string().nullable(),

    // Substituição de Professor (Performance & Métricas)
    idOriginalEmployee: Yup.string().nullable(),       // ID do professor titular da turma
    originalEmployeeName: Yup.string().nullable(),     // Nome do professor titular
    originalEmployeePhotoUrl: Yup.string().nullable(), // Foto do professor titular
    isSubstitution: Yup.boolean().default(false),      // True se outro professor cobriu a aula

    idArea: Yup.string()
        .required("O local da sessão é obrigatório"),
    areaName: Yup.string().nullable(),
        
    date: Yup.date() // Pode ser uma ISO ou Date object
        .required("A data da sessão é obrigatória"),
        
    startTime: Yup.string()
        .matches(TIME_REGEX, "Horário inicial inválido (use HH:MM)")
        .required("Informe quando começa a aula"),
        
    endTime: Yup.string()
        .matches(TIME_REGEX, "Horário final inválido (use HH:MM)")
        .required("Informe quando termina a aula"),

    maxCapacity: Yup.number()
        .typeError("A capacidade deve ser um número")
        .integer("Deve ser um número inteiro")
        .positive("Deve ser maior que zero")
        .required("A capacidade máxima para esta aula é exigida"),

    status: Yup.string()
        .oneOf(["SCHEDULED", "IN_PROGRESS", "COMPLETED", "CANCELED"], "Status da sessão inválido")
        .default("SCHEDULED"),
        
    // Contadores
    attendanceCompleted: Yup.boolean().default(false), // O professor confirmou a lista
    enrolledCount: Yup.number().integer().min(0).default(0),
    experimentalCount: Yup.number().integer().min(0).default(0),
    presentCount: Yup.number().integer().min(0).default(0),
    absentCount: Yup.number().integer().min(0).default(0),

    // Opcional por padrão ao construir, mas agora carrega dados vitais para evitar Joins!
    attendances: Yup.array().of(
        Yup.object().shape({
            idMember: Yup.string().required(),
            memberName: Yup.string().required(),
            memberPhotoUrl: Yup.string().nullable(),
            
            type: Yup.string().oneOf(["REGULAR", "TRIAL", "REPLACEMENT"]).required(),
            status: Yup.string().oneOf(["BOOKED", "PRESENT", "ABSENT", "JUSTIFIED"]).required(),
            timestamp: Yup.date().nullable() // Momento do check-in ou marcação da falta
        })
    ).default([])
});
